import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: theme.text }}>
                  ( {greeting.nickname} )
                </h2>
              )}
              <div className="greeting-bullets" style={{ color: theme.secondaryText }}>
                {greeting.bulletPoints &&
                  greeting.bulletPoints.map((point, index) => (
                    <p key={index} className="greeting-bullet-point">
                      • <strong>{point.bold}</strong> {point.text}
                    </p>
                  ))}
              </div>
              <div className="social-media-div">
                <SocialMedia theme={theme} />
              </div>
              <div className="portfolio-repo-btn-div">
                <Button
                  text="Follow Me On Github"
                  newTab={true}
                  href={greeting.portfolio_repository}
                  theme={theme}
                  className="portfolio-repo-btn"
                />
              </div>
              <div className="resume-btn-div">
                <Button text="See My Resume" newTab={true} href={greeting.resumeLink} theme={theme} />
              </div>
              {/* <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
            </div> */}
            </div>
          </div>
          <div className="greeting-image-div">
            {/* <img
							alt="saad sitting on table"
							src={require("../../assets/images/feelingProud.svg")}
						></img> */}
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
